module.exports = __webpack_public_path__ + "img/29_38.7c5d029a.png";